<template>
  <v-dialog :value="dialog" max-width="75vw" @input="val => { if (!val) $emit('emitDialog', false); showErrorValidationMsg = false; }">
    <v-card class="cmodal-card">

      <div class="cmodal-header">
        <div class="cmodal-header__left">
          <span class="cmodal-title">Relance</span>
          <span class="devis-badge">{{ numero_devis }}</span>
        </div>
        <v-btn icon dark small @click="$emit('emitDialog', false); showErrorValidationMsg = false">
          <v-icon small>mdi-close</v-icon>
        </v-btn>
      </div>

      <v-card-text class="pa-5">

        <div class="params-header">
          <div class="col-label">Statut</div>
          <div class="col-check"></div>
          <div class="col-date">Date de relance</div>
          <div class="col-comment">Commentaires</div>
        </div>

        <div
          v-for="item in devisParamsValues"
          :key="item.id_devis_param_champ"
          class="param-row"
          :class="{ 'param-row--selected': item.value }"
        >
          <div class="col-label">{{ item.libelle }}</div>
          <div class="col-check">
            <v-checkbox
              v-model="item.value"
              @click="uncheckOtherBoxes(item)"
              light
              hide-details
              dense
              class="mt-0 pt-0"
            />
          </div>
          <div class="col-date">
            <v-text-field
              v-if="item.id_devis_param_champ === 1 || item.id_devis_param_champ === 2"
              v-model="item.date"
              single-line
              outlined
              dense
              hide-details
            />
          </div>
          <div class="col-comment">
            <v-textarea
              v-model="item.commentaire"
              outlined
              dense
              auto-grow
              hide-details
              rows="2"
            />
          </div>
        </div>

        <p v-if="showErrorValidationMsg" class="error-msg mt-4">
          Veuillez cocher une case et saisir un commentaire
        </p>

      </v-card-text>

      <v-divider />

      <v-card-actions class="pa-4 justify-center">
        <v-btn color="#FF9900" rounded dark depressed @click="saveValues()">
          Enregistrer
        </v-btn>
      </v-card-actions>

    </v-card>
  </v-dialog>
</template>

<script>
import api from "@/api/devis.js";
import moment from "moment";

export default {
  props: [
    "text",
    "numero_devis",
    "dialog",
    "actions",
    "heightProp",
    "widthProp",
    "showClose",
  ],
  data() {
    return {
      devisParamsValues: [],
      showErrorValidationMsg: false,
    };
  },

  methods: {
    uncheckOtherBoxes(item) {
      if (item.value === false) {
        item.date = "";
      } else {
        item.date = moment().format("L");
      }
      this.devisParamsValues.forEach((element) => {
        if (element.id_devis_param_champ !== item.id_devis_param_champ) {
          element.value = false;
          element.date = "";
        }
      });
    },

    saveValues() {
      const result = this.devisParamsValues.filter(
        (element) => element.value === true && element.commentaire !== ""
      );
      if (result.length === 0) {
        this.showErrorValidationMsg = true;
      } else {
        this.showErrorValidationMsg = false;
        result[0]["numero_devis"] = this.numero_devis;
        result[0]["date"] = result[0]["date"] === "" ? null : result[0]["date"];

        api.saveDevisParams(result[0]).then((res) => {
          this.$emit("emitDialog", false);
          this.$emit("emitSaved", res.data);
        }).catch(() => {
          this.$store.dispatch('notify', { message: 'Erreur lors de l\'enregistrement' });
        });
      }
    },

    getDevisParams(numero_devis) {
      api.getDevisParams(numero_devis).then((res) => {
        this.devisParamsValues = res.data.devisParamsValues;
      }).catch(() => {
        this.$store.dispatch('notify', { message: 'Erreur lors du chargement' });
      });
    },
  },

  watch: {
    numero_devis(new_value) {
      this.getDevisParams(new_value);
    },
  },
};
</script>

<style lang="scss" scoped>
// ── Modal card ────────────────────────────────────────────────────
.cmodal-card {
  border-radius: 12px !important;
  overflow: hidden;
}

.cmodal-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px 20px;
  background: #0a6e97;
  color: #fff;

  &__left {
    display: flex;
    align-items: center;
    gap: 12px;
  }
}

.cmodal-title {
  font-weight: 700;
  font-size: 0.9rem;
  letter-spacing: 0.08em;
  text-transform: uppercase;
}

.devis-badge {
  background: rgba(255, 255, 255, 0.2);
  border-radius: 6px;
  padding: 2px 10px;
  font-size: 0.82rem;
  font-weight: 600;
  letter-spacing: 0.04em;
}

// ── Params table ──────────────────────────────────────────────────
.params-header {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 0 4px 8px;
  border-bottom: 2px solid #e8eef2;
  margin-bottom: 8px;

  .col-label  { font-size: 0.72rem; font-weight: 700; letter-spacing: 0.07em; color: #777; text-transform: uppercase; flex: 0 0 160px; }
  .col-check  { flex: 0 0 48px; }
  .col-date   { font-size: 0.72rem; font-weight: 700; letter-spacing: 0.07em; color: #777; text-transform: uppercase; flex: 0 0 160px; }
  .col-comment { font-size: 0.72rem; font-weight: 700; letter-spacing: 0.07em; color: #777; text-transform: uppercase; flex: 1; }
}

.param-row {
  display: flex;
  align-items: flex-start;
  gap: 12px;
  padding: 10px 4px;
  border-radius: 8px;
  transition: background 0.15s;

  &--selected {
    background: #f0f8fc;
  }

  .col-label {
    flex: 0 0 160px;
    font-size: 0.88rem;
    font-weight: 500;
    color: #333;
    padding-top: 8px;
  }

  .col-check {
    flex: 0 0 48px;
    display: flex;
    align-items: flex-start;
    padding-top: 4px;
  }

  .col-date {
    flex: 0 0 160px;
  }

  .col-comment {
    flex: 1;
  }
}

// ── Error ─────────────────────────────────────────────────────────
.error-msg {
  color: #e53935;
  font-size: 0.82rem;
  text-align: center;
  margin: 0;
}
</style>
